import React, { Component } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { inviteUser, getUsers, deleteUser, updateUserRole } from "../../actions/settings"
import APIUrls from '../../constants/ApiUrls';
import { APIManager } from "../../utils/api";
import UserCard from "../../components/settings/UserCard";
import AddItem from "../../components/settings/AddItem";
import InviteUserForm from "../../components/settings/InviteUserForm";
import imgFriend from "../../assets/images/friends-image.png";
import "./UserManagement.scss";

const ReactSwal = withReactContent(Swal);

class UserManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customerDetails: null,
      progressUsers: []
    };
    this.axiosConfig = {};
  }

  async componentDidMount() {
    // get the current users
    this.props.getUsers();

    // get the customer details
    const { customerId, tenantId } = this.props.user;
    let customerDetails = {};
    try {
      customerDetails = await this.getCustomerDetails(customerId, tenantId);
    } catch (e) {
      toast.error('Failed to get customer details: ' + e.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }
    this.setState({customerDetails});
  }

  /**
   * Refresh tokens for requests
   * @returns (Object) jwt tokens
   */
  refreshAuthorizedRequestConfig = async () => {
    const tokens = await this.props.Auth.currentSession();
    
    this.axiosConfig = {
      headers: {
        'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
        'X-Identity': tokens.idToken.jwtToken,
        "Content-Type": "application/json",
      },
      crossdomain: true
    };

    return tokens;
  }

  /**
   * Get the customer details from Stripe including current subscription plan
   * @param {String} customerId 
   * @param {String} tenantId 
   */
  getCustomerDetails = async (customerId, tenantId) => {
    await this.refreshAuthorizedRequestConfig();
  
    const response = await APIManager.Instance.call("GET", APIUrls.getCustomerDetail(customerId, tenantId), this.axiosConfig);
    return response;
  }


  onInviteUser = (userInfo) => {
    const { progressUsers } = this.state;
    progressUsers.push(userInfo);
    this.setState({ progressUsers });
    this.props.inviteUser(userInfo);
  }

  /**
   * Handle inviting a new user
   * Note: if the owner is on the solo plan, then we shoot them over to the paywall page
   * 
   */
  clickInviteUser = () => {
    const currentPlan = _.get(this.state.customerDetails, 'subscriptions.data[0].plan.nickname', '');
    // solo plan doesn't allow for additional users
    if (currentPlan && currentPlan === "Solo") {
      toast.success('🚀 Subscribe to a paid plan to add users', {
        position: toast.POSITION.TOP_RIGHT,
        pauseOnHover: true,
        autoClose: 10000
      });
      this.props.history.push('/paywall');
      return;
    }

    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <InviteUserForm
          onClose={ReactSwal.clickCancel}
          inviteUser={this.onInviteUser}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  render() {
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';
    const otherUsers = this.props.users.filter(u => u.email !== _.get(this.props, "cognitoUser.attributes['email']"));
    const currentUser = this.props.users.find(u => u.email === _.get(this.props, "cognitoUser.attributes['email']"));
    const { progressUsers } = this.state;
    const processingUsers = progressUsers.filter(pUser => {
      const existingUser = this.props.users.find(u => u.email === pUser.email);

      return !existingUser;
    });

    if (currentUser) {
      otherUsers.unshift(currentUser);
    }

    return (
      <div className="user-management-container position-relative">
        {otherUsers.filter(ou => !ou.disabled).map((u, index) => {
          if (index === 0) {
            if (isAdmin) {
              return <UserCard
                key={`${index}-${u.email}`}
                user={{
                  name: u.name,
                  email: u.email,
                  role: u.type,
                  imageUrl: _.get(this.props, "cognitoUser.attributes['custom:avatar_medium']", null),
                  userId: u.userId,
                  isConfirmed: u.isConfirmed
                }}
                isAdmin={isAdmin}
                isOwner={true}
                onClick={() => this.props.history.push('/settings')}
                deleteUser={this.props.deleteUser}
                updateUserRole={this.props.updateUserRole}
              />
            } else {
              return <UserCard
                key={`${index}-${u.email}`}
                user={{
                  name: u.name,
                  email: u.email,
                  role: u.type,
                  imageUrl: _.get(u, "cognitoUser.attributes['custom:avatar_medium']", null),
                  userId: u.userId,
                  isConfirmed: u.isConfirmed
                }}
                isAdmin={isAdmin}
                isOwner={true}
                onClick={() => this.props.history.push('/settings')}
                deleteUser={this.props.deleteUser}
                updateUserRole={this.props.updateUserRole}
              />
            }
          } else {
            return <UserCard
              key={`${index}-${u.email}`}
              user={{
                name: u.name,
                email: u.email,
                role: u.type,
                imageUrl: _.get(u, "avatar.medium", null),
                userId: u.userId,
                isConfirmed: u.isConfirmed
              }}
              isAdmin={isAdmin}
              deleteUser={this.props.deleteUser}
              updateUserRole={this.props.updateUserRole}
            />;
          }
        })}
        {
          processingUsers.map((user, index) => 
            <UserCard
              key={`inprogress_user_${index}-${user.email}`}
              user={{
                name: user.name,
                email: user.email,
                role: user.role,
              }}
              isAdmin={isAdmin}
              updateUserRole={this.props.updateUserRole}
            />
          )
        }
        {isAdmin && <AddItem onClick={this.clickInviteUser} />}
        {this.props.users.length < 4 && <img src={imgFriend} alt='friends' width="30%" className="position-absolute bottom-0 left-0 absolute-bottom" style={{ left: 10, bottom: 10 }} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cognitoUser: state.auth.cognitoUser,
  user: state.auth.tenant,
  users: state.settings.users,
  Auth: state.auth.Auth
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  inviteUser,
  getUsers,
  deleteUser,
  updateUserRole
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
